import React, { useRef, useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import MenuArrow from '../Icons/MenuArrow';


const MenuTemplate = ({ menu, subTopMenu, menuRef }) => {

  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();
  const handleToggle = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpenMenu(null);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setOpenMenu(null);
  }, [location]);
  
  const renderMenuItems = (items) => {
    const regex = /experience\s*center/i;
    return items.map((topItem, index) => (
      <li key={topItem}>
        <div className="button">
          <a  className={`${regex.test(topItem.MenuName) ? 'brd-btn' : ''} ${location.pathname === topItem.PageURL ? 'active' : ''}`} href={topItem.PageURL}>{topItem.MenuName}</a>
        </div>
      </li>
    ));
  };

  return (
    <>
      <nav aria-label="nav1" className="main_nav">
        <ul className="disclosure-nav">
          {Array.isArray(menu) && menu.map((menuGroup, index) => (
            <React.Fragment key={menuGroup}>
              {renderMenuItems(menuGroup)}
            </React.Fragment>
          ))}
        </ul>
      </nav>
      <nav aria-label="nav2" className="sub_nav">
        <ul className="disclosure-nav">
          {subTopMenu && subTopMenu[0] && subTopMenu[0].map((menu, index) => (
            <li key={menu.MenuName || index}>
              <button
                className={`button ${openMenu === menu.MenuName ? 'button-active' : 'button-inactive'}`}
                onClick={() => handleToggle(menu.MenuName)}
                aria-expanded={openMenu === menu.MenuName}
                aria-controls={`id_${menu.MenuName.replace(/\s+/g, '-').toLowerCase()}_menu`}
              >
                {menu.MenuName}&nbsp;<MenuArrow />
              </button>
              {openMenu === menu.MenuName && menu.SubMenu && menu.SubMenu.length > 0 && (
                <ul id={`id_${menu.MenuName.replace(/\s+/g, '-').toLowerCase()}_menu`} className="menu_pad20" style={{ display: "block" }}>
                  {menu.SubMenu.map((subItem, subIndex) => (
                    <li key={subItem.MenuName} className={subItem.SubMenu && subItem.SubMenu.length > 0 ? "has-submenu" : ""}>
                      <a href={subItem.PageURL} className={location.pathname === subItem.PageURL ? 'activeMenu' : ''}>{subItem.MenuName}</a>
                      {subItem.SubMenu && subItem.SubMenu.length > 0 && (
                        <>
                          {subItem.SubMenu.map((nestedSubItem, nestedSubIndex) => (
                            <a key={nestedSubItem} href={nestedSubItem.PageURL} className={`submenu ${location.pathname === nestedSubItem.PageURL ? 'activeMenu' : ''}`}>–  {nestedSubItem.MenuName}</a>
                          ))}
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default MenuTemplate;
